import { TRACKING_EVENTS_NAME } from "../../../../../../constants/trackingEvents";
import { SCREENS } from "../../../../../../routes/screens";
import { ButtonVariant } from "../../../../../core-ui/components/Button/utils";
import { Text } from "../../../../../core-ui/components/Text/Text";
import { TextStyleVariant } from "../../../../../core-ui/components/Text/TextUtils";
import { NoReleasesContainer } from "../ReleaseTableView.styles";
import { CreateReleaseButton } from "./CreateReleaseButton";

export const NoReleasesMessage = () => {
  return (
    <NoReleasesContainer>
      <Text variant={TextStyleVariant.S2} sx={{ textAlign: "center" }}>
        Upload songs or select completed projects on EngineEars to create a
        release.
      </Text>
      <CreateReleaseButton
        variant={ButtonVariant.BLACK_OUTLINED_BUTTON_BLACK_HOVER}
        analyticsEvent={{
          name: TRACKING_EVENTS_NAME.ARTIST_CLICKED_CREATE_RELEASE_BUTTON,
          data: { page: SCREENS.BOOKINGS, table: "Release Table" },
        }}
      />
    </NoReleasesContainer>
  );
};
